import configuration from '../../shared/response-types.json';

export const RESPONSE_TYPES = configuration.types;
export function resolveResponseType(value) {
  return (
    RESPONSE_TYPES.find(type => type.id === value) ||
    RESPONSE_TYPES.find(type => type.id === configuration.default)
  );
}

export function buildResponsePrompt(value) {
  const type = resolveResponseType(value);
  return `${configuration.basePrompt}\nRESPONSE TYPE: ${type.label}. ${type.prompt}`;
}
